<template>
  <div class="dashboard-container">
    <div class="header-stats ">
      <div class="header-item ">
        <div class="item_name">可提现积分</div>
        <div class="item-text-container">
          <div class="item-text">
            {{ pointsInfo.integral || 0 }}积分
          </div>
          <div class="button-container">
            <!-- <button class="withdraw-btn" @click="handleWithdraw">立即提现</button> -->
            <button class="record-btn" @click="goToWithdrawRecords">提现记录</button>
          </div>
        </div>
      </div>
      <!-- <div class="header-item ">
        <div class="item_name">累计积分</div>
        <div class="item_text">{{ pointsInfo.total_score_num }}积分</div>
      </div> -->
    </div>
    <div class="top">

      <div class="top_item color1">
        <div class="item_name">今日注册</div>
        <div class="item_text">{{ todayStats.registerNumToday }}</div>
      </div>
      <div class="top_item color2">
        <div class="item_name">今日会员充值</div>
        <div class="item_text">¥{{ todayStats.vipUpayToday }}</div>
      </div>
      <div class="top_item color3">
        <div class="item_name">今日金币充值</div>
        <div class="item_text">¥{{ todayStats.goldUpayToday }}</div>
      </div>
      <div class="top_item color4">
        <div class="item_name">今日返利</div>
        <div class="item_text">{{ todayStats.todayRebate || 0 }}积分</div>
      </div>
      <div class="top_item color5">
        <div class="item_name">今日首充金额</div>
        <div class="item_text">¥{{ rechargeStats.firstRechargeAmount }}</div>
      </div>
      <div class="top_item color6">
        <div class="item_name">今日首充次数</div>
        <div class="item_text">{{ rechargeStats.firstRechargeCount }}</div>
      </div>
      <div class="top_item color7">
        <div class="item_name">今日复充金额</div>
        <div class="item_text">¥{{ rechargeStats.repeatRechargeAmount }}</div>
      </div>
      <div class="top_item color8">
        <div class="item_name">今日复充次数</div>
        <div class="item_text">{{ rechargeStats.repeatRechargeCount }}</div>
      </div>
    </div>

    <div class="bottom">

      <div class="bottom_item color2">
        <div class="item_name">累计注册</div>
        <div class="item_text">{{ totalStats.registerNum }}</div>
      </div>
      <div class="bottom_item color3">
        <div class="item_name">累计会员充值</div>
        <div class="item_text">¥{{ totalStats.vipUpay }}</div>
      </div>
      <div class="bottom_item color4">
        <div class="item_name">累计金币充值</div>
        <div class="item_text">¥{{ totalStats.goldUpay }}</div>
      </div>
      <div class="bottom_item color3">
        <div class="item_name">累计返利</div>
        <div class="item_text">{{ totalStats.totalRebate || 0 }}积分</div>
      </div>
    </div>
    <div class="charts-section">
      <div class="charts-row">
        <el-card class="chart-card">
          <div slot="header" class="chart-header">
            <span>每日注册统计</span>
            <el-date-picker v-model="registerDateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" @change="handleRegisterDateChange" style="width: 240px;" />
          </div>
          <div class="chart-container">
            <div ref="registerChart" class="chart"></div>
          </div>
        </el-card>

        <el-card class="chart-card">
          <div slot="header" class="chart-header">
            <span>每日会员充值统计</span>
            <el-date-picker v-model="memberRechargeDateRange" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" @change="handleMemberRechargeDateChange"
              style="width: 240px;" />
          </div>
          <div class="chart-container">
            <div ref="memberRechargeChart" class="chart"></div>
          </div>
        </el-card>
      </div>

      <div class="charts-row">
        <el-card class="chart-card">
          <div slot="header" class="chart-header">
            <span>每日金币充值统计</span>
            <el-date-picker v-model="goldRechargeDateRange" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" @change="handleGoldRechargeDateChange"
              style="width: 240px;" />
          </div>
          <div class="chart-container">
            <div ref="goldRechargeChart" class="chart"></div>
          </div>
        </el-card>

        <el-card class="chart-card">
          <div slot="header" class="chart-header">
            <span>每日返利统计</span>
            <el-date-picker v-model="rebateDateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" @change="handleRebateDateChange" style="width: 240px;" />
          </div>
          <div class="chart-container">
            <div ref="rebateChart" class="chart"></div>
          </div>
        </el-card>
      </div>
    </div>

    <!-- 提现弹窗 -->
    <el-dialog title="积分提现" :visible.sync="withdrawDialogVisible" width="500px"
      :before-close="handleCloseWithdrawDialog">
      <div class="withdraw-info">
        <div class="info-item">
          <span class="info-label">剩余待提现积分：</span>
          <span class="info-value points">{{ pointsInfo.integral || 0 }}</span>
        </div>

        <div class="info-item">
          <span class="info-label">提现比例：</span>
          <span class="info-value">10积分 = ¥1.00</span>
        </div>
      </div>

      <el-form ref="withdrawForm" :model="withdrawForm" :rules="withdrawRules" label-width="100px">
        <el-form-item label="提现积分" prop="points">
          <el-input v-model="withdrawForm.points" placeholder="请输入提现积分数量" type="number" @input="calculateAmount">
            <template slot="append">积分</template>
          </el-input>
        </el-form-item>

        <el-form-item label="提现金额">
          <el-input v-model="withdrawForm.amount" placeholder="0.00" readonly style="background: #f5f7fa;">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="withdrawDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitWithdraw" :loading="withdrawLoading">
          {{ withdrawLoading ? '提交中...' : '确认提现' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getCurrUserInfo, getAction, postAction } from '@/api/user'

export default {
  name: 'Dashboard',
  data() {
    return {
      pointsInfo: {
        points: 0,
        remaining: 0,
        pointsToday: 0,
        alPoints: 0,
        integral: 0, // 可提现积分
        total_score_num: 0 // 累计积分
      },
      todayStats: {
        registerNumToday: 0,
        vipUpayToday: 0,
        goldUpayToday: 0,
        todayRebate: 0
      },
      totalStats: {
        registerNum: 0,
        vipUpay: 0,
        goldUpay: 0,
        totalRebate: 0
      },
      rechargeStats: {
        firstRechargeAmount: 0, // 今日首充金额
        firstRechargeCount: 0, // 今日首充次数
        repeatRechargeAmount: 0, // 今日复充金额
        repeatRechargeCount: 0 // 今日复充次数
      },
      registerDateRange: [],
      memberRechargeDateRange: [],
      goldRechargeDateRange: [],
      rebateDateRange: [],
      registerChart: null,
      memberRechargeChart: null,
      goldRechargeChart: null,
      rebateChart: null,

      withdrawDialogVisible: false,
      withdrawLoading: false,
      withdrawForm: {
        points: '',
        amount: '0.00'
      },
      withdrawRules: {
        points: [
          { required: true, message: '请输入提现积分数量', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const points = parseInt(value)
              if (!points || points <= 0) {
                callback(new Error('提现积分必须大于0'))
              } else if (points > (this.pointsInfo.integral || 0)) {
                callback(new Error('提现积分不能超过待提现积分'))
              } else if (points < 2000) {
                callback(new Error('最少提现200元'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      bankInfo: {} // 存储用户银行信息
    }
  },
  mounted() {
    this.fetchCurrUserInfo()
    this.fetchHomeData()
    this.initCharts()
    // 设置默认日期范围为最近7天
    this.setDefaultDateRanges()
    // 页面进入时就调用折线图接口
    this.$nextTick(() => {
      this.updateRegisterChart()
      this.updateMemberRechargeChart()
      this.updateGoldRechargeChart()
      this.updateRebateChart()
    })
  },
  beforeDestroy() {
    this.disposeCharts()
  },
  methods: {
    async fetchCurrUserInfo() {
      try {
        const res = await getCurrUserInfo()
        if (res.code === 200 && res.data) {
          this.pointsInfo = {
            points: 0,
            remaining: res.data.integral || 0,
            pointsToday: 0,
            alPoints: res.data.total_score_num || 0,
            integral: res.data.integral || 0, // 可提现积分
            total_score_num: res.data.total_score_num || 0 // 累计积分
          }

          // 存储银行信息用于提现
          if (res.data.bank_info) {
            this.bankInfo = {
              nickName: res.data.bank_info.user_name || '',
              openBank: res.data.bank_info.open_bank || '',
              branchBank: res.data.bank_info.branch_bank || '',
              bankNum: res.data.bank_info.bank_num || '',
              zfbUrl: res.data.bank_info.zfb_url || '',
              wxUrl: res.data.bank_info.wx_url || '',
              idCardFront: res.data.bank_info.id_card_front || '',
              idCardBack: res.data.bank_info.id_card_back || ''
            }
          }
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
        this.$message.error('获取用户信息失败')
      }
    },
    async fetchHomeData() {
      try {
        const res = await getAction('/api/center/getHomeData')
        if (res.code === 200 && res.data) {
          const data = res.data

          // 更新今日统计数据
          this.todayStats = {
            registerNumToday: data.today_register || 0,
            vipUpayToday: data.today_vip_recharge || 0,
            goldUpayToday: data.today_coin_recharge || 0,
            todayRebate: data.today_rebate || 0
          }

          // 更新累计统计数据
          this.totalStats = {
            registerNum: data.total_register || 0,
            vipUpay: data.total_vip_recharge || 0,
            goldUpay: data.total_coin_recharge || 0,
            totalRebate: data.total_rebate || 0
          }

          // 更新今日首充/复充统计数据
          this.rechargeStats = {
            firstRechargeAmount: data.today_first_recharge_amount || 0,
            firstRechargeCount: data.today_first_recharge_count || 0,
            repeatRechargeAmount: data.today_repeat_recharge_amount || 0,
            repeatRechargeCount: data.today_repeat_recharge_count || 0
          }

          // withdraw_score 字段已不再使用，改为从 getCurrUserInfo 获取 integral
        }
      } catch (error) {
        console.error('获取首页数据失败:', error)
        this.$message.error('获取首页数据失败')
      }
    },
    setDefaultDateRanges() {
      const end = new Date()
      const start = new Date()
      start.setDate(end.getDate() - 6) // 最近7天
      const defaultRange = [start, end]
      this.registerDateRange = [...defaultRange]
      this.memberRechargeDateRange = [...defaultRange]
      this.goldRechargeDateRange = [...defaultRange]
      this.rebateDateRange = [...defaultRange]
    },

    initCharts() {
      // 初始化四个图表
      this.registerChart = echarts.init(this.$refs.registerChart)
      this.memberRechargeChart = echarts.init(this.$refs.memberRechargeChart)
      this.goldRechargeChart = echarts.init(this.$refs.goldRechargeChart)
      this.rebateChart = echarts.init(this.$refs.rebateChart)

      // 更新图表数据
      this.updateRegisterChart()
      this.updateMemberRechargeChart()
      this.updateGoldRechargeChart()
      this.updateRebateChart()

      // 监听窗口大小变化
      window.addEventListener('resize', this.handleResize)
    },

    disposeCharts() {
      if (this.registerChart) {
        this.registerChart.dispose()
        this.registerChart = null
      }
      if (this.memberRechargeChart) {
        this.memberRechargeChart.dispose()
        this.memberRechargeChart = null
      }
      if (this.goldRechargeChart) {
        this.goldRechargeChart.dispose()
        this.goldRechargeChart = null
      }
      if (this.rebateChart) {
        this.rebateChart.dispose()
        this.rebateChart = null
      }
    },

    handleResize() {
      if (this.registerChart) this.registerChart.resize()
      if (this.memberRechargeChart) this.memberRechargeChart.resize()
      if (this.goldRechargeChart) this.goldRechargeChart.resize()
      if (this.rebateChart) this.rebateChart.resize()
    },

    handleRegisterDateChange() {
      this.updateRegisterChart()
    },

    handleMemberRechargeDateChange() {
      this.updateMemberRechargeChart()
    },

    handleGoldRechargeDateChange() {
      this.updateGoldRechargeChart()
    },

    handleRebateDateChange() {
      this.updateRebateChart()
    },

    async updateRegisterChart() {
      if (!this.registerChart) return

      let dates = []
      let data = []

      // 调用真实接口获取数据
      try {
        if (!this.registerDateRange || this.registerDateRange.length !== 2) {
          console.warn('注册统计日期范围无效')
          return
        }
        const [startDate, endDate] = this.registerDateRange
        if (!startDate || !endDate) {
          console.warn('注册统计日期参数为空')
          return
        }
        const res = await getAction('/api/center/newUserTrend', {
          startTime: this.formatDateTime(startDate),
          endTime: this.formatDateTime(endDate)
        })

        if (res.code === 200 && res.data) {
          // 处理新接口返回的键值对数据格式
          const dataObj = res.data
          dates = Object.keys(dataObj) || []
          data = Object.values(dataObj) || []
        }
      } catch (error) {
        console.error('获取每日注册数据失败:', error)
      }

      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            const data = params[0]
            return `${data.axisValue}<br/>注册人数: ${data.value}人`
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dates,
          axisLine: {
            lineStyle: {
              color: '#dcdfe6'
            }
          },
          axisLabel: {
            color: '#909399'
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#dcdfe6'
            }
          },
          axisLabel: {
            color: '#909399',
            formatter: '{value}人'
          },
          splitLine: {
            lineStyle: {
              color: '#f5f7fa'
            }
          }
        },
        series: [
          {
            name: '注册人数',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#7847f1'
            },
            lineStyle: {
              color: '#7847f1',
              width: 2
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(120, 71, 241, 0.3)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(120, 71, 241, 0.05)'
                  }
                ]
              }
            },
            data: data
          }
        ]
      }

      this.registerChart.setOption(option)
    },

    async updateMemberRechargeChart() {
      if (!this.memberRechargeChart) return

      let dates = []
      let data = []

      // 调用真实接口获取数据
      try {
        if (!this.memberRechargeDateRange || this.memberRechargeDateRange.length !== 2) {
          console.warn('会员充值统计日期范围无效')
          return
        }
        const [startDate, endDate] = this.memberRechargeDateRange
        if (!startDate || !endDate) {
          console.warn('会员充值统计日期参数为空')
          return
        }
        const res = await getAction('/api/center/newUserUpgradeTrend', {
          startTime: this.formatDateTime(startDate),
          endTime: this.formatDateTime(endDate)
        })

        if (res.code === 200 && res.data) {
          // 处理新接口返回的键值对数据格式
          const dataObj = res.data
          dates = Object.keys(dataObj) || []
          data = Object.values(dataObj) || []
        }
      } catch (error) {
        console.error('获取每日会员充值数据失败:', error)
      }

      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            const data = params[0]
            return `${data.axisValue}<br/>会员充值: ¥${data.value}`
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dates,
          axisLine: {
            lineStyle: {
              color: '#dcdfe6'
            }
          },
          axisLabel: {
            color: '#909399'
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#dcdfe6'
            }
          },
          axisLabel: {
            color: '#909399',
            formatter: '¥{value}'
          },
          splitLine: {
            lineStyle: {
              color: '#f5f7fa'
            }
          }
        },
        series: [
          {
            name: '会员充值',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#7592ff'
            },
            lineStyle: {
              color: '#7592ff',
              width: 2
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(117, 146, 255, 0.3)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(117, 146, 255, 0.05)'
                  }
                ]
              }
            },
            data: data
          }
        ]
      }

      this.memberRechargeChart.setOption(option)
    },

    async updateGoldRechargeChart() {
      if (!this.goldRechargeChart) return

      let dates = []
      let data = []

      // 调用真实接口获取数据
      try {
        if (!this.goldRechargeDateRange || this.goldRechargeDateRange.length !== 2) {
          console.warn('金币充值统计日期范围无效')
          return
        }
        const [startDate, endDate] = this.goldRechargeDateRange
        if (!startDate || !endDate) {
          console.warn('金币充值统计日期参数为空')
          return
        }
        const res = await getAction('/api/center/newUserRechargeTrend', {
          startTime: this.formatDateTime(startDate),
          endTime: this.formatDateTime(endDate)
        })

        if (res.code === 200 && res.data) {
          // 处理新接口返回的键值对数据格式
          const dataObj = res.data
          dates = Object.keys(dataObj) || []
          data = Object.values(dataObj) || []
        }
      } catch (error) {
        console.error('获取每日金币充值数据失败:', error)
      }

      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            const data = params[0]
            return `${data.axisValue}<br/>金币充值: ¥${data.value}`
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dates,
          axisLine: {
            lineStyle: {
              color: '#dcdfe6'
            }
          },
          axisLabel: {
            color: '#909399'
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#dcdfe6'
            }
          },
          axisLabel: {
            color: '#909399',
            formatter: '¥{value}'
          },
          splitLine: {
            lineStyle: {
              color: '#f5f7fa'
            }
          }
        },
        series: [
          {
            name: '金币充值',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#ffc019'
            },
            lineStyle: {
              color: '#ffc019',
              width: 2
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(255, 192, 25, 0.3)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(255, 192, 25, 0.05)'
                  }
                ]
              }
            },
            data: data
          }
        ]
      }

      this.goldRechargeChart.setOption(option)
    },

    async updateRebateChart() {
      if (!this.rebateChart) return

      let dates = []
      let data = []

      // 调用真实接口获取数据
      try {
        if (!this.rebateDateRange || this.rebateDateRange.length !== 2) {
          console.warn('返利统计日期范围无效')
          return
        }
        const [startDate, endDate] = this.rebateDateRange
        if (!startDate || !endDate) {
          console.warn('返利统计日期参数为空')
          return
        }
        const res = await getAction('/api/center/newUserRebateTrend', {
          startTime: this.formatDateTime(startDate),
          endTime: this.formatDateTime(endDate)
        })

        if (res.code === 200 && res.data) {
          // 处理新接口返回的键值对数据格式
          const dataObj = res.data
          dates = Object.keys(dataObj) || []
          data = Object.values(dataObj) || []
        }
      } catch (error) {
        console.error('获取每日返利数据失败:', error)
      }

      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            const data = params[0]
            return `${data.axisValue}<br/>返利积分: ${data.value}积分`
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dates,
          axisLine: {
            lineStyle: {
              color: '#dcdfe6'
            }
          },
          axisLabel: {
            color: '#909399'
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#dcdfe6'
            }
          },
          axisLabel: {
            color: '#909399',
            formatter: '{value}积分'
          },
          splitLine: {
            lineStyle: {
              color: '#f5f7fa'
            }
          }
        },
        series: [
          {
            name: '返利积分',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#27a5ff'
            },
            lineStyle: {
              color: '#27a5ff',
              width: 2
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(39, 165, 255, 0.3)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(39, 165, 255, 0.05)'
                  }
                ]
              }
            },
            data: data
          }
        ]
      }

      this.rebateChart.setOption(option)
    },

    generateDates(dateRange) {
      if (!dateRange || dateRange.length !== 2) {
        // 如果没有选择日期范围，返回最近7天
        const dates = []
        for (let i = 6; i >= 0; i--) {
          const date = new Date()
          date.setDate(date.getDate() - i)
          dates.push(this.formatDate(date))
        }
        return dates
      }

      const dates = []
      const start = new Date(dateRange[0])
      const end = new Date(dateRange[1])

      while (start <= end) {
        dates.push(this.formatDate(new Date(start)))
        start.setDate(start.getDate() + 1)
      }

      return dates
    },

    formatDate(date) {
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      return `${month}-${day}`
    },

    formatDateTime(date) {
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      return `${year}-${month}-${day}`
    },



    async handleWithdraw() {
      // 检查是否已有银行信息
      if (!this.bankInfo || !this.bankInfo.nickName) {
        this.$message.error('请先完善个人信息中的银行信息')
        return
      }

      this.withdrawDialogVisible = true
      this.withdrawForm = {
        points: '',
        amount: '0.00'
      }
    },

    goToWithdrawRecords() {
      this.$router.push('/withdrawal/index')
    },
    handleCloseWithdrawDialog() {
      this.withdrawDialogVisible = false
      this.withdrawForm = {
        points: '',
        amount: '0.00'
      }
    },
    calculateAmount() {
      const points = parseInt(this.withdrawForm.points) || 0
      this.withdrawForm.amount = (points / 10).toFixed(2)
    },
    async submitWithdraw() {
      this.$refs.withdrawForm.validate(async (valid) => {
        if (valid) {
          this.withdrawLoading = true

          const withdrawPoints = parseInt(this.withdrawForm.points)

          const params = {
            amount: withdrawPoints
          }

          let res = await postAction('/api/user/withdraw', params)
          console.log(res, '提现');

          if (res.code === 200) {

            this.$message.success('提现申请提交成功，请等待审核')

            this.withdrawDialogVisible = false
            this.withdrawForm = {
              points: '',
              amount: '0.00'
            }
            this.withdrawLoading = false
          } else {
            this.$message.error(res.msg || '提现申请失败')
            this.withdrawLoading = false
          }

        } else {
          this.$message.error('请输入正确的提现积分')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  padding: 15px;

  .header-stats {
    display: flex;
    margin-bottom: 15px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, .08);
    overflow: hidden;

    .header-item {
      flex: 1;
      padding: 24px 30px;
      position: relative;

      & + .header-item {
        border-left: 1px solid #f0f0f0;
      }

      .item_name {
        font-size: 14px;
        color: #909399;
        margin-bottom: 12px;
      }

      .item-text-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .item-text {
        font-size: 28px;
        font-weight: 700;
        color: #E67459;
        line-height: 1;
      }

      .button-container {
        flex-shrink: 0;
      }

      .record-btn {
        padding: 8px 20px;
        border: none;
        border-radius: 6px;
        font-size: 13px;
        cursor: pointer;
        transition: all .3s;
        background: linear-gradient(135deg, #667eea, #764ba2);
        color: #fff;

        &:hover {
          background: linear-gradient(135deg, #5a67d8, #667eea);
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(102, 126, 234, .4);
        }
      }
    }
  }

  .top {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    row-gap: 15px;
    margin-bottom: 15px;

    .top_item {
      width: 24%;
      height: 140px;
      border-radius: 20px;
      padding: 15px 0 0 25px;

      .item_name {
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        font-weight: bold;
        color: #FFF;
      }

      .item_text {
        margin-top: 8px;
        line-height: 35px;
        height: 35px;
        font-size: 20px;
        font-weight: bold;
        color: #FFF;
      }
    }

    .color1 {
      background: linear-gradient(to right, #7847f1, #be78ff);
    }

    .color2 {
      background: linear-gradient(to right, #7592ff, #a3abfe);
    }

    .color3 {
      background: linear-gradient(to right, #ffc019, #ffdb84);
    }

    .color4 {
      background: linear-gradient(to right, #27a5ff, #96d6ff);
    }

    .color5 {
      background: linear-gradient(to right, #e52d27, #ff7675);
    }

    .color6 {
      background: linear-gradient(to right, #ec008c, #f857a6);
    }

    .color7 {
      background: linear-gradient(to right, #009688, #4db6ac);
    }

    .color8 {
      background: linear-gradient(to right, #56ab2f, #a8e063);
    }
  }

  .bottom {
    display: flex;
    justify-content: space-between;

    .bottom_item {
      width: 24%;
      height: 140px;
      background-color: aqua;
      border-radius: 20px;
      padding: 15px 0 0 25px;

      .item_name {
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        font-weight: bold;
        color: #FFF;
      }

      .item_text {
        margin-top: 8px;
        line-height: 35px;
        height: 35px;
        font-size: 20px;
        font-weight: bold;
        color: #FFF;
      }
    }

    .color1 {
      background: linear-gradient(to right, #e74c3c, #ff6b6b);
    }

    .color2 {
      background: linear-gradient(to right, #9b59b6, #c39bd3);
    }

    .color3 {
      background: linear-gradient(to right, #2ecc71, #82e0aa);
    }

    .color4 {
      background: linear-gradient(to right, #3498db, #85c1e9);
    }
  }
}

.charts-section {
  margin-top: 15px;
}

.charts-row {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;

  .chart-card {
    flex: 1;
  }
}

.chart-card {
  .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.chart-container {
  width: 100%;
  height: 280px;
}

.chart {
  width: 100%;
  height: 100%;
}

.withdraw-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;

  .info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }

    .info-label {
      color: #606266;
      font-size: 14px;
    }

    .info-value {
      font-weight: bold;

      &.points {
        color: #409eff;
        font-size: 16px;
      }

      &.amount {
        color: #67c23a;
        font-size: 16px;
      }
    }
  }
}


/* 手机端适配 */
@media (max-width: 768px) {
  .dashboard-container {
    padding: 10px;

    .header-stats {
      flex-direction: column;
      margin-bottom: 10px;

      .header-item {
        padding: 16px 20px;

        & + .header-item {
          border-left: none;
          border-top: 1px solid #f0f0f0;
        }

        .item_name {
          font-size: 13px;
          margin-bottom: 8px;
        }

        .item-text {
          font-size: 24px;
        }

        .record-btn {
          padding: 6px 16px;
          font-size: 12px;
        }
      }
    }

    .top {
      flex-direction: column;
      gap: 10px;
      margin-bottom: 10px;

      .top_item {
        width: 100%;
        height: 100px;
        padding: 12px 15px;

        .item_name {
          font-size: 16px;
          line-height: 24px;
          height: auto;
        }

        .item_text {
          font-size: 18px;
          line-height: 28px;
          height: auto;
          margin-top: 5px;
        }
      }
    }

    .bottom {
      flex-direction: column;
      gap: 10px;

      .bottom_item {
        width: 100%;
        height: 100px;
        padding: 12px 15px;

        .item_name {
          font-size: 16px;
          line-height: 24px;
          height: auto;
        }

        .item_text {
          font-size: 18px;
          line-height: 28px;
          height: auto;
          margin-top: 5px;
        }
      }
    }

    .charts-section {
      margin-top: 10px;

      .charts-row {
        flex-direction: column;
        gap: 10px;
        margin-bottom: 10px;

        .chart-card {
          .chart-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;

            span {
              font-size: 14px;
            }

            .el-date-editor {
              width: 100% !important;
            }
          }
        }
      }
    }

    .chart-container {
      height: 250px;
    }

    // 提现弹窗手机端适配
    ::v-deep .el-dialog {
      width: 95% !important;
      margin: 5vh auto !important;

      .el-dialog__body {
        padding: 15px;
      }
    }

    .withdraw-info {
      padding: 12px;
      margin-bottom: 15px;

      .info-item {
        margin-bottom: 10px;

        .info-label {
          font-size: 13px;
        }

        .info-value {
          font-size: 14px;

          &.points {
            font-size: 15px;
          }
        }
      }
    }

    ::v-deep .el-form {
      .el-form-item__label {
        font-size: 13px !important;
        width: 90px !important;
      }

      .el-form-item__content {
        margin-left: 90px !important;
      }

      .el-input__inner {
        font-size: 13px;
      }
    }

    .dialog-footer {
      ::v-deep .el-button {
        font-size: 13px;
        padding: 8px 16px;
      }
    }
  }

  @media (max-width: 480px) {

    .header-stats {
      .header-item {
        padding: 14px 16px;

        .item_name {
          font-size: 12px;
          margin-bottom: 6px;
        }

        .item-text {
          font-size: 22px;
        }

        .record-btn {
          padding: 5px 14px;
          font-size: 11px;
        }
      }
    }

    // 更小屏幕弹窗适配
    ::v-deep .el-dialog {
      width: 98% !important;

      .el-dialog__body {
        padding: 10px;
      }
    }

    .withdraw-info {
      padding: 10px;
      margin-bottom: 12px;

      .info-item {
        margin-bottom: 8px;

        .info-label {
          font-size: 12px;
        }

        .info-value {
          font-size: 12px;

          &.points {
            font-size: 13px;
          }
        }
      }
    }

    ::v-deep .el-form {
      .el-form-item__label {
        font-size: 12px !important;
        width: 80px !important;
      }

      .el-form-item__content {
        margin-left: 80px !important;
      }

      .el-input__inner {
        font-size: 12px;
      }
    }

    .dialog-footer {
      ::v-deep .el-button {
        font-size: 12px;
        padding: 6px 12px;
      }
    }
  }
}
</style>
